import { cache } from 'react';

import { createServerApi } from '@/lib/server-api';

// Raw fanfic item shape from fanfics-custom/v2, further transformed by
// FanfictionGrid's transformFanficData before rendering.
// Untyped by design — mirrors the pre-existing pattern used across the
// catalog pages (app/fanfics/page.tsx, app/originals/page.tsx), where the
// SSR response is passed through as-is and shape is only normalized client-side.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RawFanficListItem = any;

export type ListingCatalogResultSSR =
  | {
      kind: 'ok';
      fanfics: RawFanficListItem[];
      totalPages: number;
      totalItems: number;
    }
  | { kind: 'error' };

/**
 * SSR request for fanfics-custom/v2 catalog listing on SEO permalink pages.
 * Cache key is the query string (not URLSearchParams instance) so React.cache
 * can dedupe identical listings within a request.
 */
export const getListingCatalogReqSSR = cache(
  async (fanficsCustomV2Query: string): Promise<ListingCatalogResultSSR> => {
    try {
      const serverApi = await createServerApi();
      const response = await serverApi.get(`/api/fanfics-custom/v2?${fanficsCustomV2Query}`);
      const fanficsData = response.data;

      return {
        kind: 'ok',
        fanfics: fanficsData?.fanfics || [],
        totalPages: fanficsData?.totalPages || 0,
        totalItems: fanficsData?.totalItems || fanficsData?.totalDocs || 0,
      };
    } catch {
      return { kind: 'error' };
    }
  },
);
